/*
 * @Description: 路由文件
 * @Author: 山淑兰
 * @Date: 2019-12-16 13:35:21
 * @LastEditTime : 2020-02-20 19:13:55
 * @LastEditors  : 山淑兰
 */
import Vue from "vue";
import VueRouter from "vue-router";
import SignUp from "../views/SignUp/Index.vue";
import CommonRoutes from "./modules/Common/index";

/**
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
*/
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "signUp",
    component: SignUp,
  },
  /**
   * @description: 个人中心
   */
  {
    path: "/personalCenter",
    // meta: { isBreadCrumbs: true },
    component: () =>
      import(/* webpackChunkName: "personalCenter" */ "../views/PersonalCenter/Index.vue"),
  },
  {
    path: "/my",
    // meta: { isBreadCrumbs: true },
    component: () =>
      import(/* webpackChunkName: "my" */ "../views/PersonalCenter/my.vue"),
  },
  {
    path: "/modifyPhone",
    // meta: { isBreadCrumbs: true },
    component: () =>
      import(/* webpackChunkName: "modifyPhone" */ "../views/PersonalCenter/modifyPhone.vue"),
  },
  

  ...CommonRoutes,
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
